module.exports = __webpack_public_path__ + "img/4.1635dcf9.jpg";